import React, { useContext, useEffect, useMemo, useState } from "react";
import {
  Box,
  Flex,
  Input,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Spinner,
  Text,
  Badge,
  Button,
  Tooltip,
  InputGroup,
  InputLeftElement,
  Grid,
  useToast,
  Portal,
  VStack,
  useDisclosure,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  DrawerCloseButton,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  Textarea,
  Select,
  Checkbox,
} from "@chakra-ui/react";
import { SearchIcon, CheckIcon, TimeIcon, CopyIcon, DownloadIcon } from "@chakra-ui/icons";
import { HiOutlineRefresh, HiOutlineDownload } from "react-icons/hi";
import debounce from "lodash/debounce";
import Pagination from "components/common/Pagination/Pagination";
import { addOneDayToDate } from "utils/dateUtils/dateUtils";
import { appRequest } from "routes";
import Datepicker from "components/common/DatePicker/DatePicker";
import { EditIcon } from "@chakra-ui/icons";
import PaymentUtrDrawer from "./PaymentUtrDrawer";
import MultiPaymentUtrDrawer from "./MultiPaymentUtrDrawer";
import FilePreviewDrawer from "./FilePreviewDrawer";
import { AppContext } from "AppProvider/AppContext";
import { routePath } from "config/pathConstant";
import { extractDocumentNumber } from "utils/functions/function";
import { FaHistory, FaEye } from "react-icons/fa";
import ApprovalHistoryModal from "../../../common/ApprovalHistoryModal/ApprovalHisoryModal";
import ForeignProcess from "../../../foreignProcess/ForeignProcess";
import moment from "moment";

const columns = [
  { key: "sr", label: "Sr. No." },
  { key: "documentId", label: "Document Id" },

  { key: "taxIdenficationNumber", label: "Tax Idenfication Number" },
  { key: "updated_At", label: "Approved On" },
  { key: "Company_Code", label: "Company Code" },
  { key: "vendorCode", label: "Vendor Code" },
  { key: "Vendor_Name", label: "Vendor Name" },
  { key: "Invoice_Number", label: "Invoice No." },
  { key: "Invoice_Date", label: "Invoice Date", type: "date" },
  { key: "currency", label: "Currency" },
  { key: "grandTotal", label: "Invoice Amount" },
  { key: "tdsAmount", label: "TDS Amount" },
  { key: "glAmount", label: "Net Amount" },
  { key: "tdsPercentage", label: "TDS %" },
  { key: "tdsSectionType", label: "TDS Selection" },
  { key: "tdsType", label: "TDS Type" },
  { key: "glDescription", label: "GL Description" },
  { key: "tdsRemarks", label: "TDS Remarks" },
  { key: "lineItems", label: "Line Items" },
  { key: "initiatorComment", label: "UE Initiator Comment" },
  { key: "lastApprovalUsername", label: "Last Approval Username" },
  { key: "postingMessage", label: "Posting Message" },
  { key: "sapForeignDocumentNumber", label: "Payment SAP Document No." },
  { key: "sapForeignRemark", label: "Payment SAP Remark" },
];

const PaymentInitiationDocument = () => {
  const { workflowProcess, accountDetails, toastNotify } = useContext(AppContext);
  const toast = useToast();

  const [selectedLineItems, setSelectedLineItems] = useState<any[]>([]);
  const { isOpen: isDrawerOpen, onOpen: onDrawerOpen, onClose: onDrawerClose } = useDisclosure();
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [dateFrom, setFromDate] = useState<Date>(() => {
    const d = new Date();
    d.setMonth(d.getMonth() - 6);
    return d;
  });

  const [dateTo, setToDate] = useState<Date>(() => new Date());
  const [isRemittanceDownloadLoading, setIsRemittanceDownloadLoading] =
    useState(false);
  const [isUploadDrawerOpen, setIsUploadDrawerOpen] = useState(false);
  const [isMultiUploadDrawerOpen, setIsMultiUploadDrawerOpen] = useState(false);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [previewFiles, setPreviewFiles] = useState<any[]>([]);

  const [isApprovalHistoryOpen, setIsApprovalHistoryOpen] = useState(false);
  const [approvalHistoryData, setApprovalHistoryData] = useState<any[]>([]);
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [documentID, setDocumentID] = useState<any>(null);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState<any[]>([]);
  const [activeTab, setActiveTab] = useState<"pending" | "done">("pending");

  const visibleColumns = useMemo(() => {
    return activeTab === "pending"
      ? columns.filter((col) => col.key !== "sapForeignDocumentNumber")
      : columns;
  }, [activeTab]);
  const [commentModel, setCommentModel] = useState<any>({
    selectedStatus: "approved",
    open: false,
    comment: "",
    isMulti: false,
  });
  const [activeRowId, setActiveRowId] = useState<string | null>(null);
  const {
    isOpen: isRemittanceModalOpen,
    onOpen: onRemittanceModalOpen,
    onClose: onRemittanceModalClose,
  } = useDisclosure();
  const [remittanceRow, setRemittanceRow] = useState<any>(null);
  const [remittanceData, setRemittanceData] = useState({
    refNo: "",
    amount: "",
    amountInAlphabet: "",
    purpose: "",
    purposeCode: "",
    selectType: "",
    paymentData: "",
    netUpAmount: "",
    tdsAmountValue: "",
    checklistRows: [] as any[]
  });

  const [foreignProcessData, setForeignProcessData] = useState<{ open: boolean; item: any }>({ open: false, item: null });

  const handleOpenApprovalHistory = (e: any, row: any) => {
    e.stopPropagation();
    setApprovalHistoryData(row.approval || []);
    setSelectedId(row._id);
    setDocumentID(row.documentId);
    setSelectedRows([row]);
    setIsApprovalHistoryOpen(true);
  };

  const handleCloseApprovalHistory = () => {
    setIsApprovalHistoryOpen(false);
    setApprovalHistoryData([]);
    setSelectedId(null);
    setDocumentID(null);
    setSelectedRows([]);
  };

  const handleGet = async (page = 1, value?: string, reset?: boolean, tabOverride?: "pending" | "done") => {
    try {
      if (!loading) setLoading(true);

      const resolvedTab = tabOverride ?? activeTab;

      const query = {
        value: reset ? "" : (value ?? search),
        page,
        limit: 35,
        dateFrom,
        dateTo: addOneDayToDate(dateTo),
        processName: workflowProcess?.processName,
        processType: workflowProcess?.processType,
        paymentStatus: reset ? "pending" : resolvedTab,
      };

      const response: any = await appRequest("document", "fetchPaymentDocuments", query);

      if (Array.isArray(response?.data)) {
        setData(response.data);
        setTotalPages(response.totalPages || 1);
        setActiveRowId(null);
        setSelectedCheckboxes([]);
      } else {
        setData([]);
        setSelectedCheckboxes([]);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // Re-create debounced fn whenever activeTab changes so the closure is always fresh
  const debouncedSearch = useMemo(
    () => debounce((value: string, tab: "pending" | "done") => handleGet(1, value, false, tab), 600),
    [activeTab] // eslint-disable-line react-hooks/exhaustive-deps
  );

  useEffect(() => {
    if (search !== "") debouncedSearch(search, activeTab);
    return () => debouncedSearch.cancel();
  }, [search, debouncedSearch]);

  useEffect(() => {
    if (workflowProcess?.processName && workflowProcess?.processType) {
      handleGet(currentPage);
    }
  }, [currentPage, workflowProcess?.processName, workflowProcess?.processType, activeTab]);

  const resetFilters = () => {
    const d = new Date();
    d.setMonth(d.getMonth() - 6);
    setFromDate(d);
    setToDate(new Date());
    setSearch("");
    setActiveTab("pending");
    handleGet(1, "", true);
  };

  const getDisplayValue = (val: any): string => {
    if (val === null || val === undefined) return "";
    if (typeof val === "object" && "label" in val) return String(val.label);
    if (typeof val === "object" && "value" in val) return String(val.value);
    return String(val);
  };

  const getLatestValues = (row: any) => {
    if (row?.values && Array.isArray(row.values) && row.values.length > 0) {
      return row.values[row.values.length - 1]?.values || {};
    }
    return row?.originalValues || {};
  };

  const getCalculatedNetAmount = (row: any) => {
    const latestValues = getLatestValues(row);
    const items = latestValues?.lineItems || latestValues?.tables?.Invoice_line_Items || [];
    const isNetUp = items.some((item: any) => {
      const sect = typeof item?.tdsSectionType === "object" ? item?.tdsSectionType?.value : item?.tdsSectionType;
      return getDisplayValue(sect).toLowerCase().trim() === "net-up";
    });

    if (isNetUp) {
      const invoiceAmt = parseFloat(getDisplayValue(latestValues?.fields?.Invoice_Amount?.editFieldValue ?? latestValues?.fields?.Invoice_Amount?.originalValue ?? row?.originalValues?.Invoice_Amount ?? "0").replace(/,/g, ''));
      const tdsTotal = items.reduce((acc: number, item: any) => {
        const val = parseFloat(getDisplayValue(item.tdsAmount).replace(/,/g, ''));
        return acc + (isNaN(val) ? 0 : val);
      }, 0);

      if (!isNaN(invoiceAmt)) {
        return (invoiceAmt - tdsTotal).toFixed(2);
      }
    } else {
      const total = items.reduce((acc: number, item: any) => {
        const val = parseFloat(getDisplayValue(item.glAmount).replace(/,/g, ''));
        return acc + (isNaN(val) ? 0 : val);
      }, 0);
      return total > 0 ? total.toFixed(2) : null;
    }
    return null;
  };

  const parseAmount = (value: any): number => {
    const parsed = parseFloat(getDisplayValue(value).replace(/,/g, ""));
    return isNaN(parsed) ? 0 : parsed;
  };

  const getLineItems = (row: any) => {
    const latestValues = getLatestValues(row);
    return latestValues?.lineItems || latestValues?.tables?.Invoice_line_Items || [];
  };

  const getFieldValue = (row: any, keys: string[]) => {
    const latestValues = getLatestValues(row);
    for (const key of keys) {
      const fieldValue =
        latestValues?.fields?.[key]?.editFieldValue ??
        latestValues?.fields?.[key]?.originalValue ??
        latestValues?.[key] ??
        row?.originalValues?.[key] ??
        row?.[key];
      const displayValue = getDisplayValue(fieldValue).trim();
      if (displayValue) return displayValue;
    }
    return "";
  };

  const getLineItemTotal = (row: any, key: string) => {
    return getLineItems(row).reduce((acc: number, item: any) => {
      return acc + parseAmount(item?.[key]);
    }, 0);
  };

  const getLineItemValues = (row: any, key: string) => {
    return Array.from(
      new Set(
        getLineItems(row)
          .map((lineItem: any) => getDisplayValue(lineItem?.[key]).trim())
          .filter(Boolean)
      )
    ).join(", ");
  };

  const buildPaymentChecklistRows = (rows: any[]) => {
    return rows.map((row: any) => {
      const rawPostingMessage = getFieldValue(row, ["postingMessage", "Posting_Message", "Posting Message"]);
      const tdsAmount = getLineItemTotal(row, "tdsAmount") || parseAmount(getFieldValue(row, ["tdsAmount", "TDS_Amount"]));
      const netAmount = parseAmount(getCalculatedNetAmount(row) ?? getFieldValue(row, ["glAmount", "Net_Amount", "netAmount"]));

      return {
        documentId: getFieldValue(row, ["documentId"]),
        invoiceNumber: getFieldValue(row, ["Invoice_Number", "invoiceNo", "invoiceNumber", "Invoice_No"]),
        postingMessage: extractDocumentNumber(rawPostingMessage) || rawPostingMessage,
        vendorName: getFieldValue(row, ["Vendor_Name", "vendorName", "beneficiaryName"]),
        vendorCode: getFieldValue(row, ["Vendor_Code", "vendorCode"]),
        currency: getFieldValue(row, ["Currency", "currency"]),
        invoiceAmount: parseAmount(getFieldValue(row, ["grandTotal", "Grand_Total", "Invoice_Amount", "invoiceAmount"])),
        tdsAmount,
        netAmount,
        tdsSelection: getLineItemValues(row, "tdsSectionType") || getFieldValue(row, ["tdsSectionType", "TDS_Selection"]),
        tdsPercentage: getLineItemValues(row, "tdsPercentage") || getFieldValue(row, ["tdsPercentage", "TDS_Percentage"]),
        tdsRemarks: getLineItemValues(row, "tdsRemarks") || getFieldValue(row, ["tdsRemarks", "TDS_Remarks"]),
        approvers: row?.approval || [],
        workflowApprovers: row?.workflowConfig?.approvals || row?.wf?.values?.[0]?.approvals || [],
      };
    });
  };

  const getStatusColor = (status: any) => {
    const s = getDisplayValue(status).toLowerCase();
    if (s.includes("approved")) return "green";
    if (s.includes("pending")) return "yellow";
    if (s.includes("rejected")) return "red";
    return "blue";
  };

  const renderCell = (row: any, col: any, index: number) => {
    if (col.key === "sr") {
      return <Box>{index + 1}</Box>;
    }

    const latestValues = getLatestValues(row);
    let rawContent = latestValues?.[col.key] ?? row?.originalValues?.[col.key] ?? row[col.key] ?? "";

    if (col.key === "currency" || col.key === "Currency") {
      rawContent = latestValues?.Currency ?? row?.originalValues?.Currency ?? row?.Currency ?? latestValues?.currency ?? row?.originalValues?.currency ?? row?.currency ?? "";
    }

    // Extract TDS fields from nested values if not found at top level
    if (
      ["tdsSectionType", "tdsType", "tdsAmount", "glAmount", "tdsPercentage", "glDescription", "tdsRemarks"].includes(col.key) &&
      (!rawContent || rawContent === "-")
    ) {
      const lineItems =
        latestValues?.lineItems ||
        latestValues?.tables?.Invoice_line_Items ||
        [];
      if (lineItems.length > 0) {
        if (col.key === "tdsAmount") {
          const total = lineItems.reduce((acc: number, item: any) => {
            const sectionTypeVal = item.tdsSectionType?.value || item.tdsSectionType?.label || item.tdsSectionType || "";
            const isGrossUp = String(sectionTypeVal).toLowerCase().includes("gross");

            if (isGrossUp) {
              const glAmt = parseFloat(getDisplayValue(item.glAmount)) || 0;
              const tdsPerc = parseFloat(getDisplayValue(item.tdsPercentage)) || 0;
              let calculatedTds = 0;
              if (tdsPerc !== 100) {
                calculatedTds = (glAmt / (100 - tdsPerc)) * tdsPerc;
              }
              return acc + calculatedTds;
            } else {
              const val = parseFloat(getDisplayValue(item.tdsAmount));
              return acc + (isNaN(val) ? 0 : val);
            }
          }, 0);
          rawContent = total > 0 ? total.toFixed(2) : "-";
        } else if (col.key === "glAmount") {
          const total = lineItems.reduce((acc: number, item: any) => {
            const val = parseFloat(getDisplayValue(item.glAmount));
            return acc + (isNaN(val) ? 0 : val);
          }, 0);
          rawContent = total > 0 ? total.toFixed(2) : "-";
        } else {
          rawContent = lineItems[0]?.[col.key] || "-";
        }
      }
    }

    if (col.key === "glAmount") {
      const netUpAmt = getCalculatedNetAmount(row);
      if (netUpAmt !== null) {
        rawContent = netUpAmt;
      }
    }


    let content: any = getDisplayValue(rawContent);
    let tooltipLabel = content;

    if (col.key === "lineItems") {
      const items =
        latestValues?.lineItems ||
        latestValues?.tables?.Invoice_line_Items ||
        [];

      if (items.length > 0) {
        return (
          <Box
            cursor="pointer"
            color="teal.600"
            fontWeight="bold"
            textDecoration="underline"
            onClick={(e) => {
              e.stopPropagation();
              setSelectedLineItems(items);
              onDrawerOpen();
            }}
          >
            {items.length} Items
          </Box>
        );
      }
      rawContent = "-";
    }

    if (col.key === "initiatorComment") {
      const level1Comments = (row?.approval || [])
        .filter((a: any) => a.level === "level-1" && a.comment && a.comment.trim() !== "")
        .map((a: any) => a.comment.trim());

      if (level1Comments.length > 0) {
        content = (
          <Text isTruncated>
            {level1Comments[0]} {level1Comments.length > 1 ? `(+${level1Comments.length - 1} more)` : ""}
          </Text>
        );
        tooltipLabel = level1Comments.length > 1
          ? level1Comments.map((c: string, idx: number) => `${idx + 1}. ${c}`).join("\n")
          : level1Comments[0];
      } else {
        content = "-";
        tooltipLabel = "-";
      }
    } else if (col.key === "lastApprovalUsername") {
      let lastUser = "-";
      const approvals = row?.approval || [];
      let maxLevel = -1;
      for (let i = approvals.length - 1; i >= 0; i--) {
        const a = approvals[i];
        if (a.name && a.status === "approved" && !a.isSkip) {
          const levelNum = parseInt(String(a.level).replace(/\D/g, ""), 10);
          if (!isNaN(levelNum) && levelNum > maxLevel) {
            maxLevel = levelNum;
            lastUser = String(a.name);
          }
        }
      }
      content = lastUser;
      tooltipLabel = content;
    } else if (col.key === "documentId") {
      content = getDisplayValue(row["documentId"] || "-");
      tooltipLabel = content;
    } else if (col.key === "updated_At") {
      content = moment(row["updated_At"]).format("DD-MM-YYYY");
      tooltipLabel = content;
    } else if (col.key === "sapForeignDocumentNumber") {
      const sapDocNo = (() => {
  const value = row?.paymentDetails?.sapForeignDocumentNumber;

  if (value === null || value === undefined) return "-";

  const match = String(value).match(/\d+/);

  return match?.[0] || "-";
})();

      content = getDisplayValue(sapDocNo || "-");
      tooltipLabel = content;
    } else if (col.key === "sapForeignRemark") {
      content = getDisplayValue(row?.paymentDetails?.sapForeignRemark || "-");
      tooltipLabel = content;
    } else if (!content || content === "-") {
      content = "-";
      tooltipLabel = "-";
    } else {
      switch (col.type) {
        case "date":
          content = new Date(rawContent).toLocaleDateString("en-IN");
          tooltipLabel = content;
          break;
        case "currency":
          content = `₹ ${Number(rawContent).toLocaleString("en-IN")}`;
          tooltipLabel = content;
          break;
        case "badge":
          content = (
            <Badge
              px={2}
              py={1}
              borderRadius="md"
              colorScheme={getStatusColor(rawContent)}
              textTransform="capitalize"
            >
              {getDisplayValue(rawContent)}
            </Badge>
          );
          tooltipLabel = getDisplayValue(latestValues?.[col.key] || row?.originalValues?.[col.key] || rawContent); // Use display value for label
          break;
        default:
          break;
      }
    }

    const displayedCellText = col.key === "postingMessage" ? (extractDocumentNumber(content) || content) : content;
    const textToCopy = typeof displayedCellText === "string" ? displayedCellText : String(tooltipLabel);

    return (
      <Tooltip
        label={<Box whiteSpace="pre-wrap">{tooltipLabel}</Box>}
        hasArrow
        isDisabled={!tooltipLabel || tooltipLabel === "-"}
      >
        <Flex align="center" maxW="150px">
          <Box whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis" flex={1}>
            {displayedCellText}
          </Box>
          <Box
            cursor="pointer"
            ml={1}
            p={1}
            borderRadius="sm"
            _hover={{ bg: "gray.100" }}
            onClick={(e) => handleCellClick(e, textToCopy)}
          >
            <CopyIcon boxSize={3} color="teal.500" />
          </Box>
        </Flex>
      </Tooltip>
    );
  };

  const isPaymentDone = (status?: any): boolean => {
    const s = getDisplayValue(status).toLowerCase().trim();
    if (!s) return false;
    return ["done", "completed", "paid", "success", "transferred", "payment done"].some(
      (v) => s === v || s.includes(v)
    );
  };

  // Fetch payment proof and convert base64 → data URL
  const fetchPaymentProof = async (fileId: string) => {
    try {
      const res: any = await appRequest("document", "previewDocument", { fileId });

      let base64String = "";


      // Adjust based on actual response structure
      if (typeof res === "string") {
        base64String = res;
      } else if (res?.base64) {
        base64String = res.base64;
      } else if (res?.data && typeof res.data === "string") {
        base64String = res.data;
      } else {
        console.warn("No base64 data found in response", res);
        return null;
      }

      // Create data URL for preview
      const dataUrl = `data:application/pdf;base64,${base64String}`;

      return {
        url: dataUrl,
        name: "Payment Proof",
        contentType: res?.contentType || "application/pdf",
      };
    } catch (err) {
      console.error("Failed to fetch payment proof:", err);
      return null;
    }
  };

  const handleDownloadExcel = async () => {
    try {
      setLoading(true);
      const query = {
        dateFrom,
        dateTo: addOneDayToDate(dateTo),
        processName: workflowProcess?.processName,
        processType: workflowProcess?.processType,
        status: "approved",
        paymentStatus: activeTab,
      };

      const response: any = await appRequest("document", "downloadPaymentInitiationExcel", query);

      if (response?.data?.base64) {
        const link = document.createElement("a");
        link.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${response.data.base64}`;
        link.download = response.data.fileName || "Payment_Initiation_Report.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        toast({
          title: "Success",
          description: "Excel downloaded successfully",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } else {
        toast({
          title: "Error",
          description: "No data available for export",
          status: "warning",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (err) {
      console.error(err);
      toast({
        title: "Error",
        description: "Failed to download Excel",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const getRowTextData = (row: any, index: number) => {
    const latestValues = getLatestValues(row);
    return visibleColumns.map((col) => {
      if (col.key === "sr") return index + 1;

      let rawContent = latestValues?.[col.key] ?? row?.originalValues?.[col.key] ?? row[col.key] ?? "";

      if (col.key === "currency") {
        rawContent = latestValues?.Currency ?? row?.originalValues?.Currency ?? row?.Currency ?? latestValues?.currency ?? row?.originalValues?.currency ?? row?.currency ?? "";
      }

      if (
        ["tdsAmount", "glAmount", "tdsPercentage", "glDescription", "tdsRemarks"].includes(col.key) &&
        (!rawContent || rawContent === "-")
      ) {
        const lineItems = latestValues?.lineItems || latestValues?.tables?.Invoice_line_Items || [];
        if (lineItems.length > 0) {
          if (col.key === "tdsAmount" || col.key === "glAmount") {
            const total = lineItems.reduce((acc: number, item: any) => {
              const val = parseFloat(getDisplayValue(item[col.key]));
              return acc + (isNaN(val) ? 0 : val);
            }, 0);
            rawContent = total > 0 ? total.toFixed(2) : "-";
          } else {
            rawContent = lineItems[0]?.[col.key] || "-";
          }
        }
      }

      if (col.key === "glAmount") {
        const netUpAmt = getCalculatedNetAmount(row);
        if (netUpAmt !== null) {
          rawContent = netUpAmt;
        }
      }

      let content = getDisplayValue(rawContent);
      if (col.key === "initiatorComment") {
        const level1Comments = (row?.approval || [])
          .filter((a: any) => a.level === "level-1" && a.comment && a.comment.trim() !== "")
          .map((a: any) => a.comment.trim());
        content = level1Comments.length > 0
          ? level1Comments.map((c: string, idx: number) => level1Comments.length > 1 ? `${idx + 1}. ${c}` : c).join("\n")
          : "-";
      } else if (col.key === "lastApprovalUsername") {
        let lastUser = "-";
        const approvals = row?.approval || [];
        let maxLevel = -1;
        for (let i = approvals.length - 1; i >= 0; i--) {
          const a = approvals[i];
          if (a.name && a.status === "approved" && !a.isSkip) {
            const levelNum = parseInt(String(a.level).replace(/\D/g, ""), 10);
            if (!isNaN(levelNum) && levelNum > maxLevel) {
              maxLevel = levelNum;
              lastUser = String(a.name);
            }
          }
        }
        content = lastUser;
      } else if (col.key === "documentId") {
        content = getDisplayValue(row["documentId"] || "-");
      } else if (col.key === "updated_At") {
        content = moment(row["updated_At"]).format("DD-MM-YYYY");
      } else if (col.key === "sapForeignDocumentNumber") {
        content = getDisplayValue(row?.paymentDetails?.sapForeignDocumentNumber || "-");
      } else if (col.key === "sapForeignRemark") {
        content = getDisplayValue(row?.paymentDetails?.sapForeignRemark || "-");
      } else if (!content || content === "-") {
        content = "-";
      } else {
        switch (col.type) {
          case "date":
            content = new Date(rawContent).toLocaleDateString("en-IN");
            break;
          case "currency":
            content = `${Number(rawContent)}`;
            break;
          default:
            break;
        }
      }
      return content;
    });
  };


  const handleCellClick = (e: React.MouseEvent, text: string) => {
    e.stopPropagation();
    if (!text || text === "-") return;
    navigator.clipboard.writeText(text)
      .then(() => toast({ title: "Copied!", status: "success", duration: 1500, isClosable: true, position: "top" }))
      .catch(() => { });
  };

  const handleRowClick = (row: any) => {
    setActiveRowId(row._id);
    // Always show original files — unchanged
    if (row?.file && Array.isArray(row.file) && row.file.length > 0) {
      setPreviewFiles(row.file);
      setIsPreviewOpen(true);
      setDocumentID(row.documentId);
    }
  };

  const handleEditClick = async (e: React.MouseEvent, row: any) => {
    e.stopPropagation();
    setDocumentID(row?.documentId)

    if (isPaymentDone(row?.paymentStatus)) {
      const fileId = row?.paymentFile;

      if (!fileId) {
        toast({
          title: "No proof available",
          description: "Payment proof file not found",
          status: "warning",
          duration: 4000,
          isClosable: true,
        });
        return;
      }

      const proofFile: any = await fetchPaymentProof(fileId);

      if (fileId) {
        setPreviewFiles([{
          _id: fileId,
          "contentType": proofFile?.contentType || "image/png"
        }]);
        setIsPreviewOpen(true);
      } else {
        toast({
          title: "Cannot load proof",
          description: "Failed to retrieve payment proof document",
          status: "error",
          duration: 5000,
          isClosable: true
        });
      }
    } else {
      // Not done → open upload drawer
      setSelectedRow(row);
      setIsUploadDrawerOpen(true);
    }
  };

  const handleUploadClose = () => {
    setIsUploadDrawerOpen(false);
    setSelectedRow(null);
    setDocumentID(null);
  };

  const handleMultiUploadClose = () => {
    setIsMultiUploadDrawerOpen(false);
  };

  const handlePreviewClose = () => {
    setIsPreviewOpen(false);
    setPreviewFiles([]);
    setDocumentID(null);
  };

  const handleSuccess = () => {
    handleGet(currentPage);
  };

  const handleMultiDownloadRemittanceForm = () => {
    if (selectedCheckboxes.length === 0) return;
    const checklistRows = buildPaymentChecklistRows(selectedCheckboxes);
    const selectedVendorCodes = new Set(
      checklistRows.map((row) => row.vendorCode).filter(Boolean)
    );

    if (selectedVendorCodes.size > 1) {
      toast({
        title: "Select one vendor",
        description: "Please select invoices from the same vendor before downloading the document template.",
        status: "warning",
        duration: 4000,
        isClosable: true,
      });
      return;
    }

    const firstRow = selectedCheckboxes[0];
    setRemittanceRow(firstRow);
    const latestValues = getLatestValues(firstRow);

    const totalSum = checklistRows.reduce((acc, row) => {
      return acc + (row.netAmount || row.invoiceAmount || 0);
    }, 0);

    let totalTds = 0;
    selectedCheckboxes.forEach((row) => {
      const latestVals = getLatestValues(row);
      const lineItems = latestVals?.lineItems || latestVals?.tables?.Invoice_line_Items || [];
      if (lineItems.length > 0) {
        totalTds += lineItems.reduce((acc: number, item: any) => {
          const sectionTypeVal = item.tdsSectionType?.value || item.tdsSectionType?.label || item.tdsSectionType || "";
          const isGrossUp = String(sectionTypeVal).toLowerCase().includes("gross");
          if (isGrossUp) {
            const glAmt = parseFloat(getDisplayValue(item.glAmount)) || 0;
            const tdsPerc = parseFloat(getDisplayValue(item.tdsPercentage)) || 0;
            let calculatedTds = 0;
            if (tdsPerc !== 100) calculatedTds = (glAmt / (100 - tdsPerc)) * tdsPerc;
            return acc + calculatedTds;
          } else {
            const val = parseFloat(getDisplayValue(item.tdsAmount));
            return acc + (isNaN(val) ? 0 : val);
          }
        }, 0);
      }
    });

    setRemittanceData({
      refNo: "",
      amount: totalSum > 0 ? totalSum.toFixed(2) : "0",
      amountInAlphabet: "",
      purpose: "",
      purposeCode: "",
      selectType: "",
      paymentData: latestValues,
      netUpAmount: totalSum > 0 ? totalSum.toFixed(2) : "",
      tdsAmountValue: totalTds > 0 ? totalTds.toFixed(2) : "",
      checklistRows
    });
    onRemittanceModalOpen();
  };

  const handleDownloadRemittanceForm = (row: any) => {
    setRemittanceRow(row);
    const latestValues = getLatestValues(row);
    const invoiceAmt =
      latestValues?.fields?.Invoice_Amount?.editFieldValue ??
      latestValues?.fields?.Invoice_Amount?.originalValue ??
      row?.originalValues?.Invoice_Amount ??
      "";

    const netUpAmt = getCalculatedNetAmount(row);

    let autoFilledTds = "";
    const lineItems = latestValues?.lineItems || latestValues?.tables?.Invoice_line_Items || [];
    if (lineItems.length > 0) {
      const total = lineItems.reduce((acc: number, item: any) => {
        const sectionTypeVal = item.tdsSectionType?.value || item.tdsSectionType?.label || item.tdsSectionType || "";
        const isGrossUp = String(sectionTypeVal).toLowerCase().includes("gross");

        if (isGrossUp) {
          const glAmt = parseFloat(getDisplayValue(item.glAmount)) || 0;
          const tdsPerc = parseFloat(getDisplayValue(item.tdsPercentage)) || 0;
          let calculatedTds = 0;
          if (tdsPerc !== 100) {
            calculatedTds = (glAmt / (100 - tdsPerc)) * tdsPerc;
          }
          return acc + calculatedTds;
        } else {
          const val = parseFloat(getDisplayValue(item.tdsAmount));
          return acc + (isNaN(val) ? 0 : val);
        }
      }, 0);
      autoFilledTds = total > 0 ? total.toFixed(2) : "";
    }

    setRemittanceData({
      refNo: "",
      amount: String(netUpAmt ?? invoiceAmt),
      amountInAlphabet: "",
      purpose: "",
      purposeCode: "",
      selectType: "",
      paymentData: latestValues,
      netUpAmount: netUpAmt ?? "",
      tdsAmountValue: autoFilledTds,
      checklistRows: []
    });
    onRemittanceModalOpen();
  };

  const submitRemittanceDownload = async () => {
    if (!remittanceRow) return;
    const refNo = remittanceData.refNo.trim();

    if (!refNo) {
      toast({
        title: "Ref No. is required",
        description: "Please enter the reference number before downloading the remittance form.",
        status: "warning",
        duration: 4000,
        isClosable: true,
      });
      return;
    }

    try {
      setIsRemittanceDownloadLoading(true);
      const response: any = await appRequest("docxTemplate", "download", {
        slug: "outward-remittance",
        ...remittanceRow,
        refNo,
        remittanceAmount: remittanceData.amount,
        tdsAmountValue: remittanceData.tdsAmountValue,
        remittanceAmountInAlphabet: remittanceData.amountInAlphabet,
        remittancePurpose: remittanceData.purpose,
        purposeCode: remittanceData.purposeCode,
        selectType: remittanceData.selectType,
        paymentData: remittanceData?.paymentData,
        netUpAmount: remittanceData?.netUpAmount,
        selectedPaymentRows: remittanceData?.checklistRows || []
      });

      if (response?.status === "error" || !response?.data?.base64) {
        throw new Error(
          response?.message || "Unable to generate outward remittance form"
        );
      }

      const byteCharacters = atob(response.data.base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], {
        type:
          response?.data?.contentType ||
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });

      const downloadUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download =
        response?.data?.fileName || "outward-remittance-request.docx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(downloadUrl);

      toastNotify({
        title: "Success",
        message: "Outward remittance form downloaded successfully",
        type: "success",
      });
      onRemittanceModalClose();
    } catch (error: any) {
      toastNotify({
        title: "Error",
        message:
          error?.message || "Unable to download the outward remittance form",
        type: "error",
      });
    } finally {
      setIsRemittanceDownloadLoading(false);
    }
  };


  return (
    <Box
      boxShadow="rgb(0 0 0 / 20%) 0px 0px 11px"
      bg="white"
      p={{ base: "1rem", md: "1.125rem 1.375rem" }}
      rounded={8}
    >
      <Grid templateColumns="1fr auto" alignItems="center" mb={4} gap="0.5rem">
        <Flex gap={4} alignItems="center">
          <Text fontSize="lg" fontWeight="600" color="teal.400">
            Payment Initiation Documents
          </Text>
        </Flex>

        <Flex gap="0.5rem" align="center" height="40px">
          <InputGroup size="sm" maxW="220px">
            <InputLeftElement pointerEvents="none" h="40px">
              <SearchIcon color="gray.400" boxSize={3} />
            </InputLeftElement>
            <Input
              h="40px"
              placeholder="Search..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </InputGroup>

          <Flex h="40px" align="center">
            <Datepicker name="startDate" label="" date={dateFrom} onDateChange={setFromDate} />
          </Flex>

          <Flex h="40px" align="center">
            <Datepicker name="endDate" label="" date={dateTo} onDateChange={setToDate} />
          </Flex>

          <Tooltip label="Search" hasArrow>
            <Button
              h="40px"
              minW="40px"
              px={0}
              bg="teal.300"
              color="white"
              size="sm"
              _hover={{ bg: "teal.400" }}
              onClick={() => handleGet(1)}
            >
              <SearchIcon boxSize={4} />
            </Button>
          </Tooltip>

          <Tooltip label="Reset" hasArrow>
            <Button
              h="40px"
              minW="40px"
              px={0}
              border="1px solid"
              borderColor="teal.300"
              bg="white"
              color="teal.400"
              size="sm"
              _hover={{ bg: "teal.300", color: "white" }}
              onClick={resetFilters}
            >
              <HiOutlineRefresh size={18} />
            </Button>
          </Tooltip>

          <Tooltip label="Download Excel" hasArrow>
            <Button
              h="40px"
              minW="40px"
              px={0}
              bg="green.400"
              color="white"
              size="sm"
              _hover={{ bg: "green.500" }}
              onClick={handleDownloadExcel}
              isLoading={loading}
            >
              <HiOutlineDownload size={18} />
            </Button>
          </Tooltip>
        </Flex>
      </Grid>

      <Box
        borderWidth="1px"
        borderColor="gray.200"
        bg="white"
        overflow="hidden"
        transition="all 0.3s"
      >
        <Flex p={3} borderBottom="1px solid" borderColor="gray.100" bg="gray.50" justify="space-between" alignItems="center">
          <Box>
            {selectedCheckboxes.length > 0 && (
              <Flex gap={3}>
                <Button
                  size="sm"
                  colorScheme="teal"
                  onClick={() => setIsMultiUploadDrawerOpen(true)}
                  display={activeTab === "pending" ? "block" :"none" }
                >
                  Update Payment Details ({selectedCheckboxes.length})
                </Button>
                <Button
                  size="sm"
                  colorScheme="blue"
                  variant="outline"
                  leftIcon={<DownloadIcon />}
                  onClick={handleMultiDownloadRemittanceForm}
                >
                  Download Document Template ({selectedCheckboxes.length})
                </Button>
              </Flex>
            )}
          </Box>
          <Flex
            bg="white"
            p="3px"
            borderRadius="full"
            gap={1}
            height="32px"
            alignItems="center"
            border="1px solid"
            borderColor="gray.200"
            boxShadow="sm"
          >
            <Button
              size="xs"
              borderRadius="full"
              px={4}
              h="26px"
              bg={activeTab === "pending" ? "teal.400" : "transparent"}
              color={activeTab === "pending" ? "white" : "gray.600"}
              shadow={activeTab === "pending" ? "sm" : "none"}
              fontWeight="600"
              variant="unstyled"
              display="flex"
              alignItems="center"
              justifyContent="center"
              _hover={{ bg: activeTab === "pending" ? "teal.500" : "gray.100" }}
              onClick={() => {
                setActiveTab("pending");
                setCurrentPage(1);
              }}
              leftIcon={<TimeIcon boxSize={3} />}
            >
              Pending
            </Button>
            <Button
              size="xs"
              borderRadius="full"
              px={4}
              h="26px"
              bg={activeTab === "done" ? "teal.400" : "transparent"}
              color={activeTab === "done" ? "white" : "gray.600"}
              shadow={activeTab === "done" ? "sm" : "none"}
              fontWeight="600"
              variant="unstyled"
              display="flex"
              alignItems="center"
              justifyContent="center"
              _hover={{ bg: activeTab === "done" ? "teal.500" : "gray.100" }}
              onClick={() => {
                setActiveTab("done");
                setCurrentPage(1);
              }}
              leftIcon={<CheckIcon boxSize={3} />}
            >
              Paid
            </Button>
          </Flex>
        </Flex>
        <Box
          maxH="650px"
          overflowY="auto"
          overflowX="auto"
          css={{
            "&::-webkit-scrollbar": {
              width: "6px",
              height: "6px",
            },
            "&::-webkit-scrollbar-track": {
              background: "transparent",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "#cbd5e0",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              background: "#a0aec0",
            },
          }}
        >
          <Table size="md" variant="unstyled">
            <Thead
              position="sticky"
              top={0}
              zIndex={10}
              bg="gray.800"
              boxShadow="sm"
            >
              <Tr>
                {visibleColumns.slice(0, 1).map((col) => (
                  <Th
                    key={col.key}
                    color="white"
                    textTransform="uppercase"
                    fontSize="xs"
                    letterSpacing="wider"
                    fontWeight="bold"
                    py={3}
                    whiteSpace="nowrap"
                    borderBottom="1px solid"
                    borderColor="gray.200"
                    position="sticky"
                    left={0}
                    bg="gray.800"
                    zIndex={11}
                    minW="90px"
                    maxW="90px"
                    px={2}
                  >
                    <Flex gap={2} alignItems="center">
                      <Checkbox
                        colorScheme="teal"
                        borderColor="gray.400"
                        isChecked={data.length > 0 && selectedCheckboxes.length === data.length}
                        isIndeterminate={selectedCheckboxes.length > 0 && selectedCheckboxes.length < data.length}
                          onClick={(e) => e.stopPropagation()}

                        onChange={(e) => {

                          if (e.target.checked) setSelectedCheckboxes([...data]);
                          else setSelectedCheckboxes([]);
                        }}
                      />
                      <Text>{col.label}</Text>
                    </Flex>
                  </Th>
                ))}
                <Th
                  color="white"
                  textTransform="uppercase"
                  fontSize="xs"
                  letterSpacing="wider"
                  fontWeight="bold"
                  py={3}
                  whiteSpace="nowrap"
                  borderBottom="1px solid"
                  borderColor="gray.200"
                  textAlign="center"
                  position="sticky"
                  left="90px"
                  bg="gray.800"
                  zIndex={11}
                  borderRight="1px solid"
                  minW="120px"
                  maxW="120px"
                  px={2}
                >
                  ACTION
                </Th>
                {visibleColumns.slice(1).map((col) => (
                  <Th
                    key={col.key}
                    color="white"
                    textTransform="uppercase"
                    fontSize="xs"
                    letterSpacing="wider"
                    fontWeight="bold"
                    py={3}
                    whiteSpace="nowrap"
                    borderBottom="1px solid"
                    borderColor="gray.200"
                  >
                    {col.label}
                  </Th>
                ))}
                <Th
                  color="white"
                  textTransform="uppercase"
                  fontSize="xs"
                  letterSpacing="wider"
                  fontWeight="bold"
                  py={3}
                  whiteSpace="nowrap"
                  borderBottom="1px solid"
                  borderColor="gray.200"
                >
                  Payment Status
                </Th>
                {activeTab === "done" && (
                  <>
                    <Th
                      color="white"
                      textTransform="uppercase"
                      fontSize="xs"
                      letterSpacing="wider"
                      fontWeight="bold"
                      py={3}
                      whiteSpace="nowrap"
                      borderBottom="1px solid"
                      borderColor="gray.200"
                    >
                      Payment Date
                    </Th>
                    <Th
                      color="white"
                      textTransform="uppercase"
                      fontSize="xs"
                      letterSpacing="wider"
                      fontWeight="bold"
                      py={3}
                      whiteSpace="nowrap"
                      borderBottom="1px solid"
                      borderColor="gray.200"
                    >
                      Bank Ref. Number
                    </Th>
                  </>
                )}
              </Tr>
            </Thead>
            <Tbody>
              {loading ? (
                <Tr>
                  <Td colSpan={visibleColumns.length + 4}>
                    <Flex justify="center" py={12}>
                      <Spinner
                        color="teal.500"
                        thickness="3px"
                        size="xl"
                        emptyColor="gray.200"
                      />
                    </Flex>
                  </Td>
                </Tr>
              ) : data.length ? (
                data.map((row, i) => (
                  <Tr
                    key={i}
                    borderBottom="1px solid"
                    borderColor="gray.100"
                    _last={{ borderBottom: "none" }}
                    bg={activeRowId === row._id ? "blue.200" : "transparent"}
                    _hover={{ bg: activeRowId === row._id ? "blue.300" : "teal.50", cursor: "pointer" }}
                    transition="all 0.2s"
                    onClick={() => handleRowClick(row)}
                  >
                    {visibleColumns.slice(0, 1).map((col) => (
                      <Td
                        key={col.key}
                        py={1}
                        fontSize="sm"
                        color="gray.700"
                        fontWeight={
                          col.key === "documentId" || col.key === "Invoice_Amount"
                            ? "medium"
                            : "normal"
                        }
                        onClick={col.key === "lineItems" ? (e) => e.stopPropagation() : undefined}
                        position="sticky"
                        left={0}
                        bg={activeRowId === row._id ? "blue.200" : "white"}
                        zIndex={1}
                        minW="90px"
                        maxW="90px"
                        px={2}
                      >
                        <Flex gap={2} alignItems="center">
                          <Checkbox
                            colorScheme="teal"
                            borderColor="gray.300"
                            isChecked={selectedCheckboxes.some((item) => item._id === row._id)}
                            onChange={(e) => {
                              if (e.target.checked) setSelectedCheckboxes((prev) => [...prev, row]);
                              else setSelectedCheckboxes((prev) => prev.filter((item) => item._id !== row._id));
                            }}
                            onClick={(e) => e.stopPropagation()}
                          />
                          <Box>{renderCell(row, col, i)}</Box>
                        </Flex>
                      </Td>
                    ))}
                    <Td
                      py={1}
                      textAlign="center"
                      onClick={(e) => e.stopPropagation()}
                      position="sticky"
                      left="90px"
                      bg={activeRowId === row._id ? "blue.200" : "white"}
                      zIndex={1}
                      borderRight="1px solid"
                      borderColor="gray.100"
                      minW="120px"
                      maxW="120px"
                      px={2}
                    >
                      <Flex gap={2} justifyContent="center" alignItems="center">
                        <Tooltip
                          label="View Approval History"
                          hasArrow
                          placement="top"
                          bg="red.600"
                          color="white"
                          fontSize="xs"
                        >
                          <Button
                            size="sm"
                            variant="solid"
                            colorScheme="red"
                            bg="red.50"
                            color="red.600"
                            _hover={{ bg: "red.500", color: "white" }}
                            onClick={(e: any) => handleOpenApprovalHistory(e, row)}
                            borderRadius="md"
                            boxShadow="sm"
                            h={8}
                            minW={8}
                            p={0}
                          >
                            <FaHistory />
                          </Button>
                        </Tooltip>

                        <Tooltip
                          label="View Complete Details"
                          hasArrow
                          placement="top"
                          bg="blue.600"
                          color="white"
                          fontSize="xs"
                        >
                          <Button
                            size="sm"
                            variant="solid"
                            colorScheme="blue"
                            bg="blue.50"
                            color="blue.600"
                            _hover={{ bg: "blue.500", color: "white" }}
                            onClick={(e: any) => {
                              e.stopPropagation();
                              setForeignProcessData({ open: true, item: row });
                            }}
                            borderRadius="md"
                            boxShadow="sm"
                            h={8}
                            minW={8}
                            p={0}
                          >
                            <FaEye />
                          </Button>
                        </Tooltip>

                        <Tooltip
                          label={
                            isPaymentDone(row?.paymentStatus)
                              ? "View Payment Proof"
                              : "Update Payment UTR"
                          }
                          hasArrow
                          placement="top"
                          bg="teal.600"
                          color="white"
                          fontSize="xs"
                          borderRadius="md"
                          display={accountDetails?.allowedTabs?.includes(routePath.paymentInitiateDocument) ? undefined : 'none'}
                        >
                          <Button
                            size="sm"
                            variant="solid"
                            colorScheme="teal"
                            bg="teal.50"
                            color="teal.600"
                            _hover={{ bg: "teal.500", color: "white" }}
                            onClick={(e: any) => handleEditClick(e, row)}
                            borderRadius="md"
                            boxShadow="sm"
                            h={8}
                            // display={row?.paymentStatus === "done" ? "none" : "block"}
                            minW={8}
                            p={0}
                          >
                            <EditIcon />
                          </Button>
                        </Tooltip>
                        <Button
                          size="sm"
                          variant="solid"
                          colorScheme="teal"
                          bg="teal.50"
                          color="teal.600"
                          _hover={{ bg: "teal.500", color: "white" }}
                          onClick={() => handleDownloadRemittanceForm(row)}
                          borderRadius="md"
                          boxShadow="sm"
                          h={8}
                          minW={8}
                          p={0}
                          display="none"
                        >
                          <DownloadIcon />
                        </Button>
                      </Flex>
                    </Td>
                    {visibleColumns.slice(1).map((col) => (
                      <Td
                        key={col.key}
                        py={1}
                        fontSize="sm"
                        color="gray.700"
                        fontWeight={
                          col.key === "documentId" || col.key === "Invoice_Amount"
                            ? "medium"
                            : "normal"
                        }
                        onClick={col.key === "lineItems" ? (e) => e.stopPropagation() : undefined}
                      >
                        {renderCell(row, col, i)}
                      </Td>
                    ))}
                    <Td py={1} maxW="180px">
                      <Tooltip
                        label={getDisplayValue(row?.paymentStatus) || "Pending"}
                        hasArrow
                        isDisabled={!row?.paymentStatus}
                      >
                        <Box>
                          <Badge
                            colorScheme={getStatusColor(row?.paymentStatus)}
                            variant="subtle"
                            px={3}
                            py={1}
                            borderRadius="full"
                            textTransform="capitalize"
                            fontSize="xs"
                            fontWeight="bold"
                            letterSpacing="wide"
                          >
                            {getDisplayValue(row?.paymentStatus) || "Pending"}
                          </Badge>
                        </Box>
                      </Tooltip>
                    </Td>
                    {activeTab === "done" && (
                      <>
                        <Td py={1} fontSize="sm" color="gray.600" maxW="150px">
                          <Tooltip
                            label={getDisplayValue(row?.paymentDetails?.paymentDueDate) || "--"}
                            hasArrow
                          >
                            <Text isTruncated cursor="default">
                              {getDisplayValue(row?.paymentDetails?.paymentDueDate) || "--"}
                            </Text>
                          </Tooltip>
                        </Td>
                        <Td py={1} fontSize="sm" color="gray.600" maxW="150px">
                          <Tooltip
                            label={getDisplayValue(row?.paymentDetails?.paymentUtrNumber) || "--"}
                            hasArrow
                          >
                            <Text isTruncated cursor="default">
                              {getDisplayValue(row?.paymentDetails?.paymentUtrNumber) || "--"}
                            </Text>
                          </Tooltip>
                        </Td>
                      </>
                    )}
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td colSpan={visibleColumns.length + 4}>
                    <Flex
                      direction="column"
                      align="center"
                      justify="center"
                      py={16}
                      textAlign="center"
                    >
                      <Box
                        bg="gray.50"
                        p={4}
                        borderRadius="full"
                        mb={3}
                        color="gray.400"
                      >
                        <SearchIcon boxSize={6} />
                      </Box>
                      <Text color="gray.600" fontSize="lg" fontWeight="medium">
                        No records found
                      </Text>
                      <Text color="gray.400" fontSize="sm" mt={1}>
                        Try adjusting your search filters or date range
                      </Text>
                    </Flex>
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </Box>
      </Box>

      <Flex justify="flex-end" mt={4}>
        <Pagination
          totalPages={totalPages}
          currentPage={currentPage}
          handlePageChange={(page) => setCurrentPage(page.selected + 1)}
        />
      </Flex>

      {isApprovalHistoryOpen && (
        <ApprovalHistoryModal
          isOpen={isApprovalHistoryOpen}
          onClose={handleCloseApprovalHistory}
          name="Payment Initiation"
          approvalHistory={approvalHistoryData}
          file={selectedRows?.length > 0 ? selectedRows[0]?.file?.[0] : null}
          id={selectedId}
          commentModel={commentModel}
          setCommentModel={setCommentModel}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          handleGet={() => handleGet(currentPage)}
          docID={documentID}
        />
      )}

      {isPreviewOpen && (
        <FilePreviewDrawer
          isOpen={isPreviewOpen}
          onClose={handlePreviewClose}
          files={previewFiles}
          docId={documentID}
        />
      )}

      {isUploadDrawerOpen && (
        <PaymentUtrDrawer
          isOpen={isUploadDrawerOpen}
          onClose={handleUploadClose}
          selectedRow={selectedRow}
          onSuccess={handleSuccess}
          docId={documentID}
        />
      )}

      {isMultiUploadDrawerOpen && (
        <MultiPaymentUtrDrawer
          isOpen={isMultiUploadDrawerOpen}
          onClose={handleMultiUploadClose}
          selectedRow={null}
          selectedRows={selectedCheckboxes}
          onSuccess={() => {
            handleSuccess();
            setSelectedCheckboxes([]);
          }}
          docId={null}
        />
      )}

      <Drawer isOpen={isDrawerOpen} onClose={onDrawerClose} placement="right">
        <DrawerOverlay />
        <DrawerContent maxW="80%">
          <DrawerCloseButton />
          <DrawerHeader borderBottom="1px solid" borderColor="gray.100" bg="gray.50" fontSize="lg" fontWeight="bold">
            Line Items Detail Breakdown
          </DrawerHeader>
          <DrawerBody p={6} bg="gray.50">
            <Box
              bg="white"
              borderRadius="xl"
              boxShadow="sm"
              border="1px solid"
              borderColor="gray.200"
              overflowX="auto"
              overflowY="auto"
              maxH="calc(100vh - 120px)"
            >
              <Table variant="simple" size="sm">
                <Thead bg="gray.50" position="sticky" top={0} zIndex={2}>
                  <Tr>
                    <Th py={4}>#</Th>
                    <Th py={4}>GL Code</Th>
                    <Th py={4}>GL Description</Th>
                    <Th py={4} isNumeric>Amount</Th>
                    <Th py={4}>Dr/Cr</Th>
                    <Th py={4}>Cost Center</Th>
                    <Th py={4}>Profit Center</Th>
                    <Th py={4}>Plant</Th>
                    <Th py={4}>Business Place</Th>
                    <Th py={4}>Internal Order</Th>
                    <Th py={4}>Business Area</Th>
                    <Th py={4}>HSN Code</Th>
                    <Th py={4} isNumeric>GST %</Th>
                    <Th py={4}>TDS Type</Th>
                    <Th py={4}>TDS Section</Th>
                    <Th py={4} isNumeric>TDS %</Th>
                    <Th py={4} isNumeric>TDS Amount</Th>
                    <Th py={4}>TDS Remarks</Th>
                    <Th py={4}>Line Narration</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {selectedLineItems.map((item: any, index: number) => (
                    <Tr key={index} _hover={{ bg: "teal.50" }} transition="background 0.2s">
                      <Td fontSize="xs" color="gray.500">
                        {index + 1}
                      </Td>
                      <Td fontSize="xs" fontWeight="bold">
                        {getDisplayValue(item.glCode || item.glAccount)}
                      </Td>
                      <Td fontSize="xs">{getDisplayValue(item.glDescription)}</Td>
                      <Td fontSize="xs" isNumeric fontWeight="bold" color="teal.700">
                        {getDisplayValue(item.glAmount)}
                      </Td>
                      <Td fontSize="xs">{getDisplayValue(item.drCrIndicator)}</Td>
                      <Td fontSize="xs">{getDisplayValue(item.costCenter)}</Td>
                      <Td fontSize="xs">{getDisplayValue(item.profitCenter)}</Td>
                      <Td fontSize="xs">{getDisplayValue(item.plantCode)}</Td>
                      <Td fontSize="xs">{getDisplayValue(item.businessPlace)}</Td>
                      <Td fontSize="xs">{getDisplayValue(item.internalOrder)}</Td>
                      <Td fontSize="xs">{getDisplayValue(item.businessArea)}</Td>
                      <Td fontSize="xs">{getDisplayValue(item.hsnCode)}</Td>
                      <Td fontSize="xs" isNumeric>
                        {getDisplayValue(item.gstPercentage)}
                      </Td>
                      <Td fontSize="xs">{getDisplayValue(item.tdsType)}</Td>
                      <Td fontSize="xs">{getDisplayValue(item.tdsSectionType)}</Td>
                      <Td fontSize="xs" isNumeric>
                        {getDisplayValue(item.tdsPercentage)}
                      </Td>
                      <Td fontSize="xs" isNumeric>
                        {getDisplayValue(item.tdsAmount)}
                      </Td>
                      <Td fontSize="xs">{getDisplayValue(item.tdsRemarks)}</Td>
                      <Td fontSize="xs">{getDisplayValue(item.lineNarration)}</Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </Box>
          </DrawerBody>
        </DrawerContent>
      </Drawer>

      <Modal isOpen={isRemittanceModalOpen} onClose={onRemittanceModalClose} size="lg" isCentered>
        <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
        <ModalContent borderRadius="2xl" boxShadow="2xl" overflow="hidden">
          <ModalHeader
            bg="teal.500"
            color="white"
            fontSize="xl"
            fontWeight="bold"
            py={4}
            display="flex"
            alignItems="center"
            gap={3}
          >
            <EditIcon w={5} h={5} />
            Remittance Request
          </ModalHeader>
          <ModalCloseButton color="white" />
          <ModalBody py={8}>
            <VStack spacing={6} align="stretch">
              <FormControl id="amount" isRequired>
                <FormLabel fontWeight="bold" fontSize="sm" color="gray.600" mb={2}>
                  Amount
                </FormLabel>
                <InputGroup size="lg">
                  <Input
                    placeholder="e.g., USD 125,000.00"
                    value={remittanceData.amount}
                    onChange={(e) =>
                      setRemittanceData({ ...remittanceData, amount: e.target.value })
                    }
                    borderRadius="xl"
                    focusBorderColor="teal.400"
                    bg="gray.50"
                    _hover={{ bg: "gray.100" }}
                    fontWeight="medium"
                  />
                </InputGroup>
              </FormControl>

              <FormControl id="tdsAmountValue">
                <FormLabel fontWeight="bold" fontSize="sm" color="gray.600" mb={2}>
                  TDS Amount
                </FormLabel>
                <InputGroup size="lg">
                  <Input
                    placeholder="e.g., 120.11"
                    value={remittanceData.tdsAmountValue}
                    onChange={(e) =>
                      setRemittanceData({ ...remittanceData, tdsAmountValue: e.target.value })
                    }
                    borderRadius="xl"
                    focusBorderColor="teal.400"
                    bg="gray.50"
                    _hover={{ bg: "gray.100" }}
                    fontWeight="medium"
                  />
                </InputGroup>
              </FormControl>

              <FormControl id="amountInWords" isRequired>
                <FormLabel fontWeight="bold" fontSize="sm" color="gray.600" mb={2}>
                  Amount in Words
                </FormLabel>
                <Textarea
                  placeholder="Enter the amount completely in words..."
                  value={remittanceData.amountInAlphabet}
                  onChange={(e) =>
                    setRemittanceData({
                      ...remittanceData,
                      amountInAlphabet: e.target.value,
                    })
                  }
                  borderRadius="xl"
                  focusBorderColor="teal.400"
                  bg="gray.50"
                  _hover={{ bg: "gray.100" }}
                  rows={3}
                  resize="none"
                />
              </FormControl>

              <FormControl id="purpose" isRequired>
                <FormLabel fontWeight="bold" fontSize="sm" color="gray.600" mb={2}>
                  Purpose
                </FormLabel>
                <Textarea
                  placeholder="Describe the reason for this remittance..."
                  value={remittanceData.purpose}
                  onChange={(e) =>
                    setRemittanceData({ ...remittanceData, purpose: e.target.value })
                  }
                  borderRadius="xl"
                  focusBorderColor="teal.400"
                  bg="gray.50"
                  _hover={{ bg: "gray.100" }}
                  rows={3}
                  resize="none"
                />
              </FormControl>

              <FormControl id="purposeCode" isRequired>
                <FormLabel fontWeight="bold" fontSize="sm" color="gray.600" mb={2}>
                  Purpose Code
                </FormLabel>
                <Input
                  placeholder="e.g., P0802"
                  value={remittanceData.purposeCode}
                  onChange={(e) =>
                    setRemittanceData({ ...remittanceData, purposeCode: e.target.value })
                  }
                  borderRadius="xl"
                  focusBorderColor="teal.400"
                  bg="gray.50"
                  _hover={{ bg: "gray.100" }}
                />
              </FormControl>

              <FormControl id="selectType" isRequired>
                <FormLabel fontWeight="bold" fontSize="sm" color="gray.600" mb={2}>
                  Select Type
                </FormLabel>
                <Select
                  placeholder="Select Type"
                  value={remittanceData.selectType}
                  onChange={(e) =>
                    setRemittanceData({ ...remittanceData, selectType: e.target.value })
                  }
                  borderRadius="xl"
                  focusBorderColor="teal.400"
                  bg="gray.50"
                  _hover={{ bg: "gray.100" }}
                  size="lg"
                >
                  <option value="Zuventus">Zuventus</option>
                  <option value="Gennova">Gennova</option>
                  <option value="Emcure">Emcure</option>
                </Select>
              </FormControl>

              <FormControl id="refNo" isRequired>
                <FormLabel fontWeight="bold" fontSize="sm" color="gray.600" mb={2}>
                  Ref No.
                </FormLabel>
                <Input
                  placeholder="Enter reference number"
                  value={remittanceData.refNo}
                  onChange={(e) =>
                    setRemittanceData({ ...remittanceData, refNo: e.target.value })
                  }
                  borderRadius="xl"
                  focusBorderColor="teal.400"
                  bg="gray.50"
                  _hover={{ bg: "gray.100" }}
                  fontWeight="medium"
                />
              </FormControl>
            </VStack>
          </ModalBody>

          <ModalFooter bg="gray.50" py={4} gap={3}>
            <Button
              variant="outline"
              onClick={onRemittanceModalClose}
              borderRadius="full"
              px={8}
              color="gray.600"
              borderColor="gray.300"
              _hover={{ bg: "gray.100", borderColor: "gray.400" }}
            >
              Cancel
            </Button>
            <Button
              bg="teal.500"
              color="white"
              _hover={{ bg: "teal.600", transform: "translateY(-1px)", boxShadow: "lg" }}
              _active={{ bg: "teal.700", transform: "translateY(0)" }}
              onClick={submitRemittanceDownload}
              isLoading={isRemittanceDownloadLoading}
              borderRadius="full"
              px={10}
              leftIcon={<DownloadIcon />}
              transition="all 0.2s"
            >
              Download Form
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {foreignProcessData.open && (
        <ForeignProcess
          name="Payment Initiation"
          isOpen={foreignProcessData.open}
          item={foreignProcessData.item}
          file={foreignProcessData.item?.file?.[0]}
          documentId={foreignProcessData.item?._id}
          docId={foreignProcessData.item?.documentId}
          onClose={() => setForeignProcessData({ open: false, item: null })}
        />
      )}
    </Box>
  );
};
export default PaymentInitiationDocument;
